// extracted by mini-css-extract-plugin
export var phone = "_59-0";